import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../../redux/modules/vehiclesActions'
import { actions as userActions } from '../../../redux/modules/userActions'
import { actions as employeesActions } from '../../../redux/modules/employeesActions'
import { actions as scheduledDeliveriesActions } from '../../../redux/modules/scheduledDeliveriesActions'
import { message, Tooltip } from 'antd'
import AddEditForm from '../../../components/vehicles/AddEditForm'
import moment from 'moment'
import { filterCaseInsensitiveStartsWith } from '../../../util'
import PaginationComponent from '../../../components/PaginationComponent'
import { getScheduledDeliveries } from '../../../selectors/vehicles'
import _ from 'lodash'

const propTypes = {}

class Vehicles extends Component {
  constructor(props) {
    super(props)
    this.props.vehiclesRefresh()
    this.props.getUsers()
    this.props.getUserRoles()
    this.props.employeesRefresh()
    this.state = {
      modalVisible: false,
      currentId: null,
      currentVehicle: null,
      followUpAssignToType: 'user'
    }
  }

  handleToggleAddEditForm = () => {
    if (this.state.modalVisible) {
      this.setState({
        currentId: null,
        currentVehicle: null
      })
    }
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  handleAddVehicle = values => {
    this.props.createVehicle({
      content: values,
      userId: this.props.authentication.user.userId
    })

    this.handleToggleAddEditForm()
    message.success('Vehicle created')
  }

  handleEditVehicle = values => {
    values.updated_by_id = this.props.authentication.user.userId
    this.props.editVehicle({
      content: values,
      vehicleId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentVehicle: null
    })

    this.handleToggleAddEditForm()
    message.success('Vehicle edited')
  }

  handleDeleteVehicle = () => {
    this.props.deleteVehicle({
      vehicleId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentVehicle: null
    })

    this.handleToggleAddEditForm()
    message.success('Vehicle deleted')
  }

  handleRowClick = row => {
    this.setState(
      {
        currentId: row.id,
        currentVehicle: row
      },
      () => {
        this.props.getVehicleAttachments({ vehicleId: row.id })
        this.props.getVehicleNote({ vehicleId: row.id })
        this.props.getVehicleFollowUp({ vehicleId: row.id })
        this.props.fetchScheduledDeliveries({ vehicleId: row.id })
        this.handleToggleAddEditForm()
      }
    )
  }

  setStatusVehicle = status => {
    const payload = {
      status: status ? 'active' : 'inactive',
      updated_by_id: this.props.authentication.user.userId,
      updated_date: moment().format('YYYY/MM/DD HH:mm:ss')
    }
    this.props.setStatusVehicle({
      content: payload,
      vehicleId: this.state.currentId
    })
  }

  uploadVehicleAttachment = param => {
    this.props.uploadVehicleAttachment({
      formData: param.formData,
      vehicleId: this.state.currentId
    })
  }

  updateVehicleAttachmentDescription = param => {
    this.props.updateVehicleAttachmentDescription(param)
  }

  deleteVehicleAttachment = param => {
    this.props.deleteVehicleAttachment(param)
  }

  // notes things
  handleToggleNoteEditArea = () => {
    this.setState({
      noteAddEditContainer: !this.state.noteAddEditContainer
    })
  }

  createNote = params => {
    this.props.createVehicleNote({
      content: params,
      userId: this.props.authentication.userId,
      vehicleId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editVehicleNote({
      content: params,
      noteId: this.state.currentNoteId,
      vehicleId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteVehicleNote({
      noteId: this.state.currentNoteId,
      vehicleId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  // follow ups things
  handleToggleFollowUpEditArea = () => {
    this.setState({
      followUpAddEditContainer: !this.state.followUpAddEditContainer
    })
  }

  handleResetFollowUpForm = () => {
    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  createFollowUp = params => {
    params.vehicle_id = this.state.currentId
    this.props.createVehicleFollowUp({
      content: params,
      vehicleId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()
  }

  updateFollowUp = params => {
    this.props.editVehicleFollowUp({
      content: params,
      followUpId: this.state.currentFollowUpId,
      vehicleId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()

    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  deleteFollowUp = () => {
    this.props.deleteVehicleFollowUp({
      followUpId: this.state.currentFollowUpId,
      vehicleId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()

    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  handleRowFollowUpClick = row => {
    this.setState({
      followUpAddEditContainer: true,
      currentFollowUp: row,
      currentFollowUpId: row.id,
      followUpAssignToType: row.assigned_to_id ? 'user' : 'role'
    })
  }

  changeAssignedToType = e => {
    this.setState({
      followUpAssignToType: e.target.value
    })
  }

  render() {
    const {
      payload,
      vehicleVehicleAttachments,
      loadingVehicleAttachments,
      uploadingVehicleAttachment,
      deletingVehicleAttachment,
      vehiclesNotes,
      vehiclesFollowUps
    } = this.props.vehiclesActions
    const employees = _.get(this.props, 'employeesActions.payload.data')
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <AddEditForm
            currentId={this.state.currentId}
            userId={this.props.authentication.user.userId}
            modalVisible={this.state.modalVisible}
            handleToggleAddEditForm={this.handleToggleAddEditForm}
            handleAddVehicle={this.handleAddVehicle}
            handleEditVehicle={this.handleEditVehicle}
            handleDeleteVehicle={this.handleDeleteVehicle}
            currentVehicle={this.state.currentVehicle}
            setStatusVehicle={this.setStatusVehicle}
            employees={employees}
            // attachments props
            uploadAttachment={this.uploadVehicleAttachment}
            updateAttachmentDescription={this.updateVehicleAttachmentDescription}
            deleteAttachment={this.deleteVehicleAttachment}
            attachmentList={vehicleVehicleAttachments && vehicleVehicleAttachments.data}
            loadingAttachments={loadingVehicleAttachments}
            uploadingAttachment={uploadingVehicleAttachment}
            deletingAttachment={deletingVehicleAttachment}
            // notes props
            currentNote={this.state.currentNote}
            currentNoteId={this.state.currentNoteId}
            notes={vehiclesNotes && vehiclesNotes.data}
            handleToggleNoteEditArea={this.handleToggleNoteEditArea}
            noteAddEditContainer={this.state.noteAddEditContainer}
            createNote={this.createNote}
            handleRowNoteClick={this.handleRowNoteClick}
            updateNote={this.updateNote}
            deleteNote={this.deleteNote}
            // follow ups props
            currentFollowUp={this.state.currentFollowUp}
            currentFollowUpId={this.state.currentFollowUpId}
            followUps={vehiclesFollowUps && vehiclesFollowUps.data}
            handleToggleFollowUpEditArea={this.handleToggleFollowUpEditArea}
            followUpAddEditContainer={this.state.followUpAddEditContainer}
            createFollowUp={this.createFollowUp}
            handleRowFollowUpClick={this.handleRowFollowUpClick}
            updateFollowUp={this.updateFollowUp}
            deleteFollowUp={this.deleteFollowUp}
            autocompleteUsers={
              this.props.userActions &&
              this.props.userActions.users &&
              this.props.userActions.users.data
            }
            autocompleteRoles={
              this.props.userActions &&
              this.props.userActions.roles &&
              this.props.userActions.roles.data
            }
            followUpAssignToType={this.state.followUpAssignToType}
            changeAssignedToType={this.changeAssignedToType}
            handleResetFollowUpForm={this.handleResetFollowUpForm}
            scheduledDeliveries={this.props.scheduledDeliveries}
            deleteScheduledDelivery={this.props.deleteScheduledDelivery}
          />
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/vehicles">Vehicles</Link>
                </li>
              </ol>
            </nav>
            <h2>Vehicles</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Vehicles
                <div className="jobsBarAdd">
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel" onClick={this.handleToggleAddEditForm}>
                    NEW VEHICLE
                  </div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                filterable
                defaultFilterMethod={filterCaseInsensitiveStartsWith}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'Name',
                        id: 'name',
                        accessor: 'name',
                        Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
                      },
                      {
                        Header: 'Driver',
                        accessor: 'driver',
                        id: 'driver',
                        Cell: d => {
                          const r = `${d.original.driver ? d.original.driver : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Status',
                        accessor: 'status'
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { vehiclesActions, authentication, userActions, employeesActions },
  ownProps
) => ({
  vehiclesActions,
  authentication,
  userActions,
  employeesActions,
  scheduledDeliveries: getScheduledDeliveries(vehiclesActions)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, userActions, employeesActions), dispatch),
  deleteScheduledDelivery: id => dispatch(scheduledDeliveriesActions.deleteScheduledDelivery(id))
})

Vehicles.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Vehicles))



// WEBPACK FOOTER //
// ./src/containers/vehicles/vehicles/VehiclesContainer.js